import { translatePhrases } from './translate-phrases';
import type { RequestParams } from './utils/api';

export type PreProcessor = (phrases: string[]) => string[];
export type PostProcessor = (
  translatedPhrases: string[],
  originalPhrases: string[]
) => string[];

export type ProcessPhrasesProps = {
  phrases: string[];
  requestParams: RequestParams;
  storeFilter?: (value: string) => boolean;
  preProcessors?: PreProcessor[];
  postProcessors?: PostProcessor[];
};

export async function translatePhrasesProcessor({
  phrases,
  requestParams,
  storeFilter,
  preProcessors = [],
  postProcessors = []
}: ProcessPhrasesProps) {
  try {
    let phrasesToTranslate = phrases;
    for (const preProcessor of preProcessors) {
      phrasesToTranslate = preProcessor(phrasesToTranslate);
    }

    if (phrasesToTranslate.length !== phrases.length) {
      console.error(
        `Currently filter phrases is not allowed. Array length must be the same.`
      );
      return phrases;
    }

    let translatedPhrases = await translatePhrases({
      phrases: phrasesToTranslate,
      params: requestParams,
      storeFilter
    });
    for (const postProcessor of postProcessors) {
      translatedPhrases = postProcessor(translatedPhrases, phrases);
    }

    return translatedPhrases;
  } catch {
    return phrases;
  }
}
